import { Component } from '@angular/core';

import { BehaviorSubject, of } from 'rxjs';

import { CamDepartmentNameComponent, CamOrganizationsService } from '@camelot/project';

import { TestIdDirective } from '@camelot/testing-harness';

const department$ = new BehaviorSubject({ id: 'dep-1', name: 'Initial name' });

const organizationsServiceMock = {
  department: { get$: () => department$.asObservable() },
  fetchDepartment$: () => of(department$.value),
};

@Component({
    imports: [CamDepartmentNameComponent, TestIdDirective],
    providers: [{ provide: CamOrganizationsService, useValue: organizationsServiceMock }],
    template: `
    <cam-department-name camTestId="cr-first" departmentId="dep-1" />
    <cam-department-name camTestId="cr-second" departmentId="dep-1" />
    <button camTestId="cr-mutate" (click)="this.mutate()">mutate</button>
  `
})
export class CacheReactivityCase {
  public mutate(): void {
    department$.next({ id: 'dep-1', name: 'Updated name' });
  }
}
